<template>
    <div class="a-form-inputs p-dependency-on-income">
        <accordion>
            <accordion-item :has-error="!deceasedIncomeValid">
                <h2 slot="header">
                    Deceased's Income
                </h2>
                <income name="Deceased" :income="theDeceased.income"
                        :person="theDeceased"
                        @action="updateTheDeceasedIncome"
                        tooltipValue="theDeceased"></income>
            </accordion-item>
            <accordion-item v-for="(dependant, index) in dependants" :has-error="!dependantIncomeValid(index)" v-if="determineAge(dependant) > 21">
                <h2 slot="header">
                    Dependant {{index + 1}} Income
                </h2>
                <income name="Claimant" :income="dependant.income" :index="index"
                        :person="dependant"
                        @action="updateTheDependantIncome"
                        tooltipValue="dependant"></income>
            </accordion-item>
            <accordion-item v-if="!hasSplitPeriods">
                <h2 slot="header">
                    The Multiplicand
                </h2>
                <multiplicand></multiplicand>
            </accordion-item>
            <accordion-item>
                <h2 slot="header">
                    The Multipliers & Dependency
                </h2>
                <multipliers></multipliers>
            </accordion-item>
        </accordion>
        <step-button :next-valid="updateValid()"></step-button>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import Accordion from 'components/accordion/Accordion.vue';
    import AccordionItem from 'components/accordion/AccordionItem.vue';
    import Multipliers from 'pages/fatal-accident-claims/dependency/steps/dependency-on-income/Multipliers.vue';
    import Multiplicand from 'pages/fatal-accident-claims/dependency/steps/dependency-on-income/Mutiplicand.vue';
    import Income from 'pages/fatal-accident-claims/dependency/steps/dependency-on-income/Income.vue';
    import StepButton from 'components/StepButton.vue';
    import {isStepValid, setStepValid} from 'services/routingMethods';
    import moment from "moment";

    export default {
        components: {
            Accordion,
            AccordionItem,
            Income,
            StepButton,
            Multiplicand,
            Multipliers
        },
        computed: {
            ...mapGetters('fatal/dependency/deceased', {
                theDeceased: 'theDeceased',
                deceasedIncomeValid: 'theDeceasedIncomeValid',
            }),
            ...mapGetters('fatal/dependency/dependants', {
                dependants: 'dependants',
                dependantsIncomeValid: 'allDependantsIncomeValid',
                dependantIncomeValid: 'dependantIncomeValid',
                dependencyOnIncomeValid: 'getDependencyOnIncomeValid',
                hasSplitPeriods: 'hasSplitPeriods',
            }),
            ...mapGetters('fatal/dependency/claimDetails', ['value'])
        },
        data() {
            return {valid: false};
        },
        mounted(){
            this.updateValid();
        },
        methods: {
            ...mapActions('fatal/dependency/deceased', {
                updateDeceasedIncome: 'updateDeceasedIncome',
            }),
            ...mapActions('fatal/dependency/dependants', {
                updateDependantIncome: 'updateDependantIncome',
            }),
            updateTheDeceasedIncome(val) {
                this.updateDeceasedIncome(val).then(this.updateValid);
            },
            updateTheDependantIncome(val) {
                this.updateDependantIncome(val).then(this.updateValid);
            },
            updateValid() {
                if (typeof this.dependencyOnIncomeValid !== 'undefined') {
                    this.valid = this.dependencyOnIncomeValid;
                } else {
                    this.valid = isStepValid(3);
                }
                setStepValid(this.valid);
                return this.valid;
            },
            determineAge(person) {
                return moment(this.value('assumedSettlement'), 'DD/MM/YYYY').diff(moment(person.dateOfBirth, 'DD/MM/YYYY'), 'years');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// DependencyOnIncome.vue?6b963f1e